import axios from "axios";
import store from "@/store";
import router from "@/router";

export default {
    namespaced: true,
    state: {
        transaction: {},
        factor: {}
    },
    mutations: {
        setTransaction(state, response) {
            state.transaction = response;
        },
        setFactor(state, factor) {
            state.factor = factor
        }

    },
    actions: {
        createTransaction({commit}, order) {
            const user_id = store.getters["User/getUserId"];
            axios
                .get(`/user/${user_id}/order/${order}/transaction`)
                .then((res) => {

                    const url = res.data.data.payment_url
                    console.log(res);
                    if (url === 'FREE') {
                        router.push({name: 'Orders'})
                    } else {
                        window.location.href = url;
                    }
                })
                .catch((error) => {
                    store.dispatch("ShoppingCart/userOrderUnpaid")
                    console.log(error);
                });
        },
        verifyTransaction({commit}, form) {
            axios
                .put(
                    `/user/${form.user}/order/${form.order}/transaction?Authority=${form.Authority}`
                )
                .then((res) => {
                    const response = res.data.data;
                    store.commit("ShoppingCart/setUserOrderPaidItems", response);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showTransactionDetail({commit}, order) {
            const user_id = store.getters["User/getUserId"];
            axios
                .post(`/user/${user_id}/order/${order}/transaction`)
                .then((res) => {
                    const response = res.data.data;
                    store.commit("ShoppingCart/setSidebarBasketData", response);
                    commit("setFactor", response);
                    store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
                    store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
                    commit("setTransaction", response.transaction);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        autoPrintShowTransactionDetail({commit}, order) {
            const user_id = store.getters["User/getUserId"];
            return axios.post(`/user/${user_id}/order/${order}/transaction`)
        },
        getFactor({commit}, orderId) {
            axios.post(`product/products-user/${orderId}`)
                .then((res) => {
                    const factor = res.data.data;
                    commit("setFactor", factor);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
    getters: {
        getTransaction: (state) => state.transaction,
        getFactor: (state) => state.factor
    },
};
